export const customerUsersState = {
  name: 'customers.customer.users',
  url: '/users',
  resolve: {
    users: (customer) => {
      'ngInject'
      return customer.getUsers()
    },
  },
  views: {
    'content@customers': 'customerUsersComponent',
  },
}



// WEBPACK FOOTER //
// ./app/users/users.states.js